import React, { useState, useEffect } from 'react';
import './Hero2.css';
import { photosAPI } from '../../services/api';

const DEFAULT_IMAGES = [
  { id: 'default-1', src: '/photos/bled-jesen.jpg', alt: 'Lake Bled in Autumn' },
  { id: 'default-2', src: '/photos/bled-zima.jpg', alt: 'Lake Bled in Winter' },
  { id: 'default-3', src: '/photos/bohinj-jesen.jpg', alt: 'Bohinj Lake in Autumn' },
  { id: 'default-4', src: '/photos/bohinj-autumn.jpg', alt: 'Bohinj in Fall' }
];

const Hero2 = ({ content }) => {
  const [images, setImages] = useState(DEFAULT_IMAGES);
  const [currentImage, setCurrentImage] = useState(0);
  const heading = content?.hero_heading || '';
  const subheading = content?.hero_subheading || '';

  useEffect(() => {
    const loadHeroImages = async () => {
      try {
        const response = await photosAPI.getPhotos();
        if (!Array.isArray(response.data) || response.data.length === 0) return;

        const apiImages = response.data
          .filter((photo) => photo?.filename)
          .map((photo, index) => ({
            id: photo.id || `photo-${index}`,
            src: `/photos/${encodeURIComponent(photo.filename)}`,
            alt: photo.alt_text || photo.original_name || photo.filename
          }));

        if (apiImages.length > 0) {
          setImages(apiImages);
          setCurrentImage((prevImage) => prevImage % apiImages.length);
        }
      } catch (error) {
        console.error('Failed to load hero images:', error);
      }
    };

    loadHeroImages();
  }, []);

  // Auto-rotate images every 10 seconds
  useEffect(() => {
    if (images.length <= 1) return undefined;

    const interval = setInterval(() => {
      setCurrentImage((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000); // 10 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const activeImage = images[currentImage] || images[0] || DEFAULT_IMAGES[0];

  return (
    <section className="hero2">
      <div className="hero2-main-image">
        <img 
          src={activeImage.src} 
          alt={activeImage.alt}
          className="hero2-featured-image"
          decoding="async"
          fetchpriority="high"
          loading="eager"
          width="1920"
          height="1080"
        />
        <div className="hero2-overlay"></div>
        
        {/* Thumbnails positioned in bottom right corner */}
        <div className="hero2-image-selector">
          <div className="hero2-thumbnails">
            {images.map((image, index) => (
              <button
                key={image.id}
                className={`hero2-thumbnail ${currentImage === index ? 'active' : ''}`}
                onClick={() => setCurrentImage(index)}
                aria-label={`View ${image.alt}`}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  decoding="async"
                  width="200"
                  height="140"
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="hero2-content">
        <div className="hero2-container">
          {heading && (
            <h1 className="hero2-main-text">
              {heading}
              {subheading && <span className="hero2-main-subline">{subheading}</span>}
            </h1>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero2;
